<template>
  <section class="form-list">
    <el-form
      class="form"
      ref="form"
      :rules="rules"
      :model="salary"
      label-position="left"
      label-width="160px"
    >
      <el-form-item label="管理员">
        <v-avatar-nickname :value="administrator.avatar" :nickname="administrator.nickname"/>
      </el-form-item>

      <el-form-item v-if="isAdministrator" label="所属门店" prop="store_id">
        <v-select-store
          class="w100"
          v-model="salary.store_id"
          :disabled-ids="administrator.store_ids"
          :has-private="true"
        />
      </el-form-item>

      <el-form-item label="职位" prop="administrator_role_id">
        <v-select-administrator-role class="w100" v-model="salary.administrator_role_id"/>
      </el-form-item>

      <el-form-item label="底薪">
        <v-input-money class="w100" :max="99999.99" v-model="salary.base_pay"/>
      </el-form-item>
      <el-form-item label="公司社保">
        <v-input-money class="w100" :max="99999.99" v-model="salary.social_insurance"/>
      </el-form-item>
      <el-form-item label="门店社保">
        <v-input-money class="w100" :max="99999.99" v-model="salary.store_insurance"/>
      </el-form-item>

      <el-form-item label="个人社保">
        <v-input-money class="w100" :max="99999.99" v-model="salary.personal_insurance"/>
      </el-form-item>

      <el-form-item label="业绩任务">
        <v-input-money class="w100" :max="999999.99" v-model="administrator.task_income"/>
      </el-form-item>
      <el-form-item label="未完成底薪比例">
        <v-input-money class="w100" v-model="administrator.base_pay_rate"/>
      </el-form-item>
      <el-form-item label="完成后提成比例">
        <v-input-money class="w100" v-model="administrator.commission_rate"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">
          立即添加至{{isAdministrator ? '该门' : '本'}}店
        </el-button>
        <el-button @click="RouteConfig.administratorSalaryList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from "@/router/config";
  import { mapGetters } from 'vuex';
  import { show } from '@/api/administrator';
  import { store } from '@/api/administratorRoleMerge';
  import { toCent } from "@/utils/number";

  export default {
    name: RouteConfig.administratorSalaryAdd.name,
    data: () => ({
      RouteConfig,
      isSaving: false,
      administrator: {
        nickname: '',
        avatar: '',
        store_ids: [],
      },
      salary: {
        administrator_id: 0,
        store_id: 0,
        administrator_role_id: 0,
        base_pay: 0,
        social_insurance: 0,
        personal_insurance: 0,
        store_insurance: 0,

        task_income: 0,
        base_pay_rate: 0,
        commission_rate: 0,
      },
      rules: {
        store_id: [{required: true, message: '请选择所属门店', trigger: 'change'}],
        administrator_role_id: [{ required: true, message: '请选择职位', trigger: 'change' }],
      },
    }),
    computed: {
      ...mapGetters([
        'isAdministrator',
      ]),
      id() {
        return +this.$route.params.id || 0;
      },
    },
    beforeMount() {
      this.show();
    },
    methods: {
      async show() {
        const { isError, data } = await show(this.id);
        if (isError) return;

        const { administrator } = this;
        Object.keys(data).forEach(key => {
          if (key in administrator) administrator[key] = data[key];
        });
      },
      handleSubmit() {
        if (this.isSaving) return;

        this.$refs.form.validate(async (isSuccess) => {
          if (!isSuccess) return;

          this.isSaving = true;

          const postData = { ...this.salary };
          postData.administrator_id = this.id;
          postData.base_pay = toCent(postData.base_pay);
          postData.social_insurance = toCent(postData.social_insurance);
          postData.store_insurance = toCent(postData.store_insurance);

          postData.personal_insurance = toCent(postData.personal_insurance);
          postData.task_income = toCent(postData.task_income);
          postData.base_pay_rate = toCent(postData.base_pay_rate);
          postData.commission_rate = toCent(postData.commission_rate);

          const { isError } = await store(postData);
          this.isSaving = false;
          if (isError) return;

          RouteConfig.administratorSalaryList.push();
        });
      },

    },
  };
</script>
